import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "common-container"
};
const _hoisted_4 = {
  class: "form-container"
};
import { computed, onMounted, ref } from 'vue';
import { ElCol, ElRow, ElForm, ElInput, ElSelect, ElOption, ElMessage } from 'element-plus';
import { request } from '@/manager/net_manager';
import { getPosition, isAdminType, isApostleType } from '@/tools/utils';
import store from '@/store';
import SectsSkillEditCard from '@/components/Skills/SectsSkillEditCard.vue';
import MaskerLayer from '@/components/Basic/MaskerLayer.vue';
import RolePropsEditCard from '@/components/Props/RolePropsEditCard.vue';
import 'element-plus/es/components/date-picker/style/css';
import 'element-plus/es/components/form/style/css'; // refs

export default {
  __name: 'AccountWorkbenches',

  setup(__props) {
    const message = ref(null);
    const loading = ref(false);
    const explanations = ref([]); // 公共数据

    const apostle = ref(null);
    const drama = ref(null);
    const workTypes = ref([]); // 提交表单

    const explanationsForm = ref({
      title: '',
      additionalTo: '',
      content: ''
    }); // computed

    const worldOutlook = computed(() => {
      return store.state.world_outlook ? store.state.world_outlook : null;
    });
    const worldOutlookArray = computed(() => {
      return store.state.world_outlook_array ?? [];
    });
    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : null); // 依赖wo的数据

    const apostles = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.apostles ?? null;
    }); // functions

    const getData = () => {
      if (worldOutlookArray.value.length === 0) {
        request('world_outlook/get_world_outlook_list/', {
          'is_precis': true
        }, 'GET').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            store.commit('update_world_outlook_array', response.data);
          }
        });
      }
    };

    const resetData = () => {
      apostle.value = null;
      drama.value = null;

      if (explanationsForm.value.title !== '') {
        explanationsForm.value = {
          title: '',
          additionalTo: '',
          content: ''
        };
      }
    };

    const getWOData = () => {
      if (!apostles.value) {
        request('world_outlook/get_wo_apostles/', {
          'world_outlook_id': worldOutlook.value.id
        }, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            store.commit('update_wo_info', {
              wo_id: worldOutlook.value.id,
              key: 'apostles',
              value: response.data
            });
          }
        });
      }
    };

    const workTypesChanged = item => {
      const index = workTypes.value.indexOf(item);

      if (index > -1) {
        workTypes.value.splice(index, 1);
      } else {
        workTypes.value.push(item);
      }
    };

    const getExplanations = () => {
      if (worldOutlook.value) {
        loading.value = true;
        request('world_outlook/get_entry_explanations_list/', {
          'world_outlook_id': worldOutlook.value.id,
          'is_precis': true
        }, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            explanations.value = response.data;
          }

          loading.value = false;
        });
      }
    };

    const onSubmit = key => {
      if (message.value) {
        message.value.close();
      }

      let url = '';
      let parameters = {};

      if (key === 'explanations') {
        url = 'world_outlook/create_entry_explanations/';
        parameters = explanationsForm.value;
        parameters.world_outlook_id = worldOutlook.value.id;
      }

      if (parameters && url) {
        request(url, parameters, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code !== 0) {
            ElMessage.error({
              message: response.msg,
              duration: 1500
            });
          } else {
            ElMessage.success({
              message: '操作完成',
              duration: 1500
            });
            resetData();
          }
        });
      }
    }; // lifecycle


    onMounted(() => {
      getData();

      if (worldOutlook.value) {
        getWOData();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_check_tag = _resolveComponent("el-check-tag");

      const _component_el_divider = _resolveComponent("el-divider");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form_item = _resolveComponent("el-form-item");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("text", null, _toDisplayString(_unref(getPosition)(userType.value)) + "工作台", 1), _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)), _createElementVNode("text", null, "「 " + _toDisplayString(worldOutlook.value ? worldOutlook.value.name : '尚未选择世界观') + " 」", 1)]), _createElementVNode("div", _hoisted_3, [_createVNode(_unref(ElCol), null, {
        default: _withCtx(() => [_unref(isAdminType)(userType.value) ? (_openBlock(), _createBlock(_unref(ElRow), {
          key: 0
        }, {
          default: _withCtx(() => [_createVNode(_component_el_check_tag, {
            checked: workTypes.value.includes('explanations'),
            onChange: _cache[0] || (_cache[0] = $event => workTypesChanged('explanations'))
          }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode(" 创建条目 ", -1)]))]),
            _: 1
          }, 8, ["checked"]), _createVNode(_component_el_check_tag, {
            checked: workTypes.value.includes('create_skill'),
            onChange: _cache[1] || (_cache[1] = $event => workTypesChanged('create_skill'))
          }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode(" 创建技能 ", -1)]))]),
            _: 1
          }, 8, ["checked"]), _createVNode(_component_el_check_tag, {
            checked: workTypes.value.includes('role_prop_create'),
            onChange: _cache[2] || (_cache[2] = $event => workTypesChanged('role_prop_create'))
          }, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode(" 创建角色道具 ", -1)]))]),
            _: 1
          }, 8, ["checked"])]),
          _: 1
        })) : _unref(isApostleType)(userType.value) ? (_openBlock(), _createBlock(_unref(ElRow), {
          key: 1
        }, {
          default: _withCtx(() => [_createVNode(_component_el_check_tag, {
            checked: workTypes.value.includes('role_prop_create'),
            onChange: _cache[3] || (_cache[3] = $event => workTypesChanged('role_prop_create'))
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode(" 创建角色道具 ", -1)]))]),
            _: 1
          }, 8, ["checked"])]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      })]), _createElementVNode("div", _hoisted_4, [_createVNode(_unref(ElCol), null, {
        default: _withCtx(() => [workTypes.value.includes('explanations') ? (_openBlock(), _createBlock(_unref(ElRow), {
          key: 0
        }, {
          default: _withCtx(() => [_createVNode(_component_el_divider), _createVNode(_unref(ElForm), {
            model: explanationsForm.value,
            "label-width": "auto"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElRow), {
              class: "form-row"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ElCol), {
                span: 16
              }, {
                default: _withCtx(() => [_createVNode(_unref(ElInput), {
                  modelValue: explanationsForm.value.title,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => explanationsForm.value.title = $event),
                  maxlength: "32",
                  placeholder: "输入条目名称",
                  round: "",
                  type: "text",
                  clearable: "",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_unref(ElCol), {
                offset: 1,
                span: 7
              }, {
                default: _withCtx(() => [_createVNode(_unref(ElSelect), {
                  modelValue: explanationsForm.value.additionalTo,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => explanationsForm.value.additionalTo = $event),
                  placeholder: "选择从属的父级条目",
                  "no-data-text": "无数据",
                  filterable: "",
                  remote: "",
                  "remote-method": getExplanations,
                  loading: loading.value
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(explanations.value, (item, index) => {
                    return _openBlock(), _createBlock(_unref(ElOption), {
                      key: index,
                      label: item['title'],
                      value: item['id']
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue", "loading"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_unref(ElInput), {
              modelValue: explanationsForm.value.content,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => explanationsForm.value.content = $event),
              type: "textarea",
              clearable: "",
              "show-word-limit": "",
              round: "",
              placeholder: "输入条目内容",
              maxlength: "256"
            }, null, 8, ["modelValue"]), _createVNode(_unref(ElRow), {
              style: {
                "justify-content": "flex-end"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  onClick: _cache[7] || (_cache[7] = $event => onSubmit('explanations'))
                }, {
                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("创建条目", -1)]))]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"])]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      })]), workTypes.value.includes('create_skill') ? (_openBlock(), _createBlock(MaskerLayer, {
        key: 0,
        onClose: _cache[9] || (_cache[9] = $event => workTypesChanged('create_skill'))
      }, {
        default: _withCtx(() => [_createVNode(SectsSkillEditCard, {
          onClose: _cache[8] || (_cache[8] = $event => workTypesChanged('create_skill'))
        })]),
        _: 1
      })) : _createCommentVNode("", true), workTypes.value.includes('role_prop_create') ? (_openBlock(), _createBlock(MaskerLayer, {
        key: 1,
        onClose: _cache[11] || (_cache[11] = $event => workTypesChanged('role_prop_create'))
      }, {
        default: _withCtx(() => [_createVNode(RolePropsEditCard, {
          onClose: _cache[10] || (_cache[10] = $event => workTypesChanged('role_prop_create'))
        })]),
        _: 1
      })) : _createCommentVNode("", true)]);
    };
  }

};